<template>
  <!-- 累計計算コンポーネント(子) -->
  <div id="monthlydata">
      <CRow v-if="success.length">
        <ul>
          <li style="color: blue" v-for="well in success" :key="well">
            {{ "※" + well }}
          </li>
        </ul>
      </CRow>
      <CRow v-if="errors.length">
        <ul>
          <li style="color: red" v-for="error in errors" :key="error">
            {{ "※" + error }}
          </li>
        </ul>
      </CRow>
      <CRow>
        <CCol>
          <div class="container px-0">
            <div class="table-responsive">
             <table class="table table-bordered w-auto mx-auto summary-leave-table">
                <tr>
                  <th>(日)</th>
                  <th nowrap>前月残</th>
                  <th nowrap>今月発生</th>
                  <th nowrap>今月消化</th>
                  <th nowrap>今月残</th>
                </tr>
                <tr>
                  <th
                    scope="row"
                    rowspan="2" 
                    style="color: black; background-color: white"
                  >
                    有給
                  </th>
                  <td>
                      <span>{{ paid }}</span>
                      <input type="hidden" :value="paid" />
                  </td>
                  <td>
                    <span>{{ get_paid }}</span>
                    <input type="hidden" :value="get_paid" />
                  </td>
                  <td>
                    <span>{{ usePaid }}</span>
                    <input type="hidden" :value="usePaid" />
                  </td>
                  <td>
                    <span>{{ savePaidDisplay  }}</span>
                    <input type="hidden" :value="savePaidDisplay" />
                  </td>
                </tr>
                <tr>
                <td colspan="4" style="text-align:center; font-weight:bold;">
                  <span :style="paidDaysUsedStyle">今期消化日数 {{ termPaidDaysUsedLabel }}</span>（付与月：{{ paidDaysAdd }}月）
                    <a
                      href="#"
                      class="help-icon help-icon-inline"
                      @click.prevent="openPaidLeaveRuleModal"
                      aria-label="有休付与ルールを表示"
                    >
                      ?
                    </a>
                  <span v-if="shouldWarnPaidDaysUsed" class="paid-used-warn"><br><b>付与月までに最低5日は消化して下さい</b></span>
                </td>
                </tr>
                <tr>
                  <th
                    scope="row"
                    style="color: black; background-color: white"
                  >
                    代休
                  </th>
                  <td>
                    <span>{{ instead }}</span>
                    <input type="hidden" :value="instead" />
                  </td>
                  <td>
                    <span>{{ get_instead }}</span>
                    <input type="hidden" :value="get_instead" />
                  </td>
                  <td>
                    <span>{{ useInstead }}</span>
                    <input type="hidden" :value="useInstead" />
                  </td>
                  <td>
                    <span>{{ saveInsteadDisplay  }}</span>
                    <input type="hidden" :value="saveInsteadDisplay" />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </CCol>
        <CCol>
          <div class="container px-0">
            <div class="table-responsive">
             <table class="table table-bordered w-auto mx-auto">
                <tr>
                  <th nowrap>規定時間</th>
                  <th nowrap>時間外</th>
                  <th nowrap>夜勤</th>
                  <th nowrap>遅刻</th>
                  <th nowrap>規定勤務</th>
                </tr>
                <tr>
                  <td>
                    <span>{{ durationTime }}</span>
                    <input type="hidden" :value="durationTime" />
                  </td>
                  <td>
                    <span>{{ overTotal }}</span>
                    <input type="hidden" :value="overTotal" />
                  </td>
                  <td>
                    <span>{{ nightTotal }}</span>
                    <input type="hidden" :value="nightTotal" />
                  </td>
                  <td>
                    <span>{{ lateCount }}</span>回
                    <input type="hidden" :value="lateCount" />
                  </td>
                  <td>
                    <span>{{ duration }}</span>日
                    <input type="hidden" :value="duration" />
                  </td>
                </tr>
                <tr>
                  <th nowrap>作業</th>
                  <th nowrap>欠勤</th>
                  <th nowrap>法定休日</th>
                  <th nowrap>早退</th>
                  <th nowrap>作業</th>
                </tr>
                <tr>
                  <td>
                    <span>{{ actualTime }}</span>
                    <input type="hidden" :value="actualTime" />
                  </td>
                  <td>
                    <span>{{ absentTime }}</span>
                    <input type="hidden" :value="absentTime" />
                  </td>
                  <td>
                    <span>{{ holidayTotal }}</span>
                    <input type="hidden" :value="holidayTotal" />
                  </td>
                  <td>
                    <span>{{ earlyCount }}</span>回
                    <input type="hidden" :value="earlyCount" />
                  </td>
                  <td>
                    <span>{{ actual }}</span>日
                    <input type="hidden" :value="actual" />
                  </td>
                </tr>
                <span :style="{ color: workTimeStatus.color, 'font-weight': 'bold', 'margin-left': '5px' }">
                  {{ workTimeStatus.text }}
                </span>
              </table>
            </div>
          </div>
        </CCol>
      </CRow>
      <div v-if="!fromExternal">
        <CRow>
          <CCol class="text-center">
            <save-button
              :class="'edit-form__submit-btn + btn btn-primary'"
              :label="'保存'"
              :loading="loading"
              :disabled="statusBtn"
              @click="register"
              />
            <br />※
            保存後、他月次申請とまとめて「承認申請一覧」にて承認申請を行ってください。
          </CCol>
        </CRow>
      </div>
      <!-- 有休付与ルール（通常の労働者）モーダル --> 
      <CModal
        :show.sync="showPaidLeaveRuleModal"
        @close="closePaidLeaveRuleModal"
        centered
        size="lg"                              
        class="paid-rule-modal"                
      >                                        
        <CModalHeader :close-button="true">有休付与ルール（通常）</CModalHeader> 

        <CModalBody class="paid-rule-modal-body"> 
          <div class="table-responsive"> 
            <table class="table table-bordered mb-0"> 
              <tr>
                <th class="plr-rowhead">継続勤務年数（年）</th>
                <th class="plr-colhead text-center">0.5</th>
                <th class="plr-colhead text-center">1.5</th>
                <th class="plr-colhead text-center">2.5</th>
                <th class="plr-colhead text-center">3.5</th>
                <th class="plr-colhead text-center">4.5</th>
                <th class="plr-colhead text-center">5.5</th>
                <th class="plr-colhead text-center">6.5以上</th>
              </tr>
              <tr>
                <th class="plr-rowhead">付与日数（日）</th>
                <td class="text-center">10</td>
                <td class="text-center">11</td>
                <td class="text-center">12</td>
                <td class="text-center">14</td>
                <td class="text-center">16</td>
                <td class="text-center">18</td>
                <td class="text-center">20</td>
              </tr>
            </table> 
          </div> 
          <!-- 注釈（上期/下期） --> 
          <div class="paid-rule-note mb-2">
            <div>【有休付与確認について】</div> 
            <div>本画面は報告対象月の有休データとなるので、付与された月に付与による増加分の有休消化は可能ですが</div>
            <div>付与日数の本画面上及び給与明細での確認は付与月の翌月提出時となります。</div> 
            <div>例：4月付与の場合は、5月月初提出時の4月勤務表にて付与表示</div>
            <div class="mt-2">【上期（4月1日基準）10月1日以降3月31日迄に入社した従業員の場合】</div> 
            <div>入社後に最初に到来する4月1日に勤続6か月とみなし、以降勤続年数に応じて上表のとおり付与となります。</div> 
            <div class="mt-2">【下期（10月1日基準）4月1日以降9月30日迄に入社した従業員の場合】</div> 
            <div>入社後最初に到来する10月1日に勤続6か月とみなし、以降勤続年数に応じて上表のとおり付与となります。</div> 
          </div> 
        </CModalBody> 

        <template #footer> 
          <button class="btn btn-secondary" @click="closePaidLeaveRuleModal">閉じる</button> 
        </template> 
      </CModal> 
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import ConstList from "./../ConstList";
import SaveButton from '../common/SaveButton';
import { toApiTimeValue } from '../utils/timeValue';

export default {
  name: "MonthlyData",
  components: {
    SaveButton,
  },
  data() {
    return {
      over: this.overTime || [],
      deducts: this.deduct || [],
      nights: this.nightWork || [],
      holidays: this.holiday || [],
      items: [],
      late: "",
      early: "",
      take_paid: "",
      remain_paid: "",
      remain_instead: "",
      defined_day: "",
      sum_day: "",
      sum_time: "",
      sum_over: "",
      sum_deduction: "",
      sum_night: "",
      sum_holiday: "",
      success: [],
      errors: [],
      loading: false,
      submit_flg: false,
      showPaidLeaveRuleModal: false,
    };
  },
  props: {
    userId: Number,
    today: Array,
    fromExternal:Boolean,
    monthDay: Array,
    outBasic: String,
    startBasic: Array,
    endBasic: Array,
    breakBasic: Array,
    start: Array,
    end: Array,
    rest: Array,
    attendance1: Array,
    attendance2: Array,
    remarks: Array,
    year: String,
    month: String,
    totalTime: Array,
    overTime: Array,
    holiday: Array,
    nightWork: Array,
    nightRest: Array,
    deduct: Array,
    earlyMorningShiftBasic: String,
    lateNightShiftBasic: String,
    midnightBasic: String,
    nightShiftTimes: String,
    dateChangeShiftTimes: String,
    paid: String,
    savePaid: String,
    paidDaysUsed: String,
    paidDaysAdd: String,
    saveInstead: String,
    get_paid: String,
    instead: String,
    addInstead: String,
    statusBtn: Boolean,
    baseTimeMin: Array,
    baseTimeMax: Array,
    projectId: Array,
  },
  methods: {
    calcTotal(tmpTime) {
      if (!tmpTime) return '00:00'
      if(typeof tmpTime === "undefined") return '00:00'
     let totalMinute = 0;
      for (var i = 0; i < tmpTime.length; i++)  {
        if (!tmpTime[i] || tmpTime[i] === "" || tmpTime[i] === null) continue;
        const timeList = tmpTime[i].split(":");
        if (timeList.length != 2) continue; // 不正なフォーマットはスキップ
        const hour = timeList[0];
        const minute = timeList[1];

        const hh = Number(hour);
        const mm = Number(minute);
        if (!Number.isFinite(hh) || !Number.isFinite(mm)) continue;
        totalMinute += Number(minute) + Number(hour)*60;
      }
      const hSum = Math.floor(totalMinute / 60);
      const mSum = totalMinute % 60;
      const hTotal = hSum < 10 ? "0" + hSum : hSum;
      const mTotal = mSum < 10 ? "0" + mSum : mSum;
      return hTotal + ":" + mTotal;
    },
    // 前月残（有給）のエラーチェック
    paid_error: function () {
      // if ((this.paid === "") && ((this.get_paid !== "") || (this.instead !== ""))) {
      //   this.errors.push("前月残(有給)を入力してください")
      // } else if ((this.paid !== "") && ((!this.paid.match(/^[0-9]*$/)) && (!this.paid.match(/^\d{1,2}.\d{1}$/)))) {
      //   this.errors.push('前月残(有給)は入力例のように、半角数字と記号のみを用いて入力してください')
      // }
    },
    // 今月発生（有給）のエラーチェック
    getPaid_error: function () {
      // if ((this.get_paid === "") && ((this.paid !== "") || (this.instead !== ""))) {
      //   this.errors.push("今月発生(有給)を入力してください")
      // }
      // if ((this.get_paid !== "") && ((!this.get_paid.match(/^[0-9]*$/)) && (!this.get_paid.match(/^\d{1,2}.\d{1}$/)))) {
      //   this.errors.push('今月生(有給)は入力例のように、半角数字と記号のみを用いて入力してください')
      // }
    },
    // 前月残（代休）のエラーチェック
    instead_error: function () {
      // if ((this.instead === "") && ((this.paid !== "") || (this.get_paid !== ""))) {
      //   this.errors.push("前月残(代休)を入力してください")
      // }
      // if ((this.instead !== "") && ((!this.instead.match(/^[0-9]*$/)) && (!this.instead.match(/^\d{1,2}.\d{1}$/)))) {
      //   this.errors.push('前月残(代休)は入力例のように、半角数字と記号のみを用いて入力してください')
      // }
    },
    // DBへ登録処理と更新処理メソッド
    register: function () {
      if (this.submit_flg) return;
      this.submit_flg = true;
      this.loading = true;
      this.items = [];
      let n = 0;
      while (n < this.monthDay.length) {
        const day = n + 1 < 10 ? "0" + (n + 1) : n + 1;
        const formattedMonth = this.month < 10 ? "0" + this.month : this.month;
        const item = {
          // 開始時刻
          start_time: this.start[n] ? this.start[n] + ":00" : null,
          // 終了時刻
          end_time: this.end[n] ? this.end[n] + ":00" : null,
          // 休憩時間
          break_time: this.rest[n] ? this.rest[n] + ":00" : null,
          // 夜勤休憩
          night_rest: toApiTimeValue(this.nightRest[n]),
          // 勤怠1
          attendance_id1: this.attendance1[n],
          // 勤怠2
          attendance_id2: this.attendance2[n],
          // 作業内容
          remarks: this.remarks[n],
          // 勤務時間
          working_time: this.totalTime[n] ? this.totalTime[n] + ":00" : null,
          // 時間外時間
          overtime_time: this.overTime[n] ? this.overTime[n] + ":00" : null,
          // 休日出勤時間
          holiday_time: this.holiday[n] ? this.holiday[n] + ":00" : null,
          // 夜勤時間
          night_time: this.nightWork[n] ? this.nightWork[n] + ":00" : null,
          // 控除時間
          deduction_time: this.deduct[n] ? this.deduct[n] + ":00" : null,
          // 年月日
          date: this.year + "-" + formattedMonth + "-" + day,
          // ユーザID
          user_id: this.userId,
          sum_leave_early: this.earlyCount,
          sum_late: this.lateCount,
          paid_holiday_pre: this.paid,
          paid_holiday_added: this.get_paid,
          paid_holiday_used: this.usePaid,
          paid_holiday_remain: this.savePaidDisplay,
          paid_days_used: this.termPaidDaysUsedValue,
          substitute_holiday_pre: this.instead,
          substitute_holiday_added: this.get_instead,
          substitute_holiday_used: this.useInstead,
          substitute_holiday_remain: this.saveInsteadDisplay,
          defined_attendance_day: this.duration,
          sum_attendance_day: this.actual,
          defined_work_time: this.durationTime,
          sum_work_time: this.actualTime,
          sum_over_time: this.overTotal,
          sum_deduction_time: this.absentTime,
          sum_night_time: this.nightTotal,
          sum_holiday_time: this.holidayTotal,
          project_id: this.projectId?.[n] ?? null,
        };
        this.items.push(item);
        n++;
      }
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/update", this.items)
        .then(() => {          
          this.submit_flg = false;
          this.$emit('updateAllData');
          this.$store.commit('set', ['sidebarBadgeRefreshTick', Date.now()]);
          alert(ConstList.REGISTER_MESSAGE);
        })
        .catch((error) => {
          this.submit_flg = false;
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(()=> {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(()=> {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.submit_flg = false;
          this.loading = false;
        });
    },
    hmToMinutes(v) {
      if (v === null || v === undefined) return NaN;
      const s = String(v).trim();
      if (s === '') return NaN;

      // "H:MM" 形式
      if (s.includes(':')) {
        const [h, m = '0'] = s.split(':');
        const hh = Number(h);
        const mm = Number(m);
        if (!Number.isFinite(hh) || !Number.isFinite(mm)) return NaN;
        return hh * 60 + mm;
      }

      // 数字だけの場合 → 「時間」と解釈する
      const hh = Number(s);
      if (!Number.isFinite(hh)) return NaN;
      return hh * 60;   // ★ ここを「分」ではなく「時間→分」に修正
    },

    formatDiff(mins) {
      const abs = Math.abs(mins);
      const h = Math.floor(abs / 60);
      const m = abs % 60;
      // 分は必ず2桁表示
      return `${h}:${m.toString().padStart(2, '0')}`;
    },
    openPaidLeaveRuleModal: function () {
      this.showPaidLeaveRuleModal = true;
    },
    closePaidLeaveRuleModal: function () {
      this.showPaidLeaveRuleModal = false;
    },
  },
  watch: {
    totalTime: {
      immediate: true,
      handler() {
        this.updateCalculations?.();
      },
    },
    holiday: {
      immediate: true,
      handler() {
        this.holidays = this.holiday;
      }
    },
    deduct: {
      immediate: true,
      handler() {
        this.deducts = this.deduct;
      }
    }
  },
  computed: {
    total() {
    return this.totalTime || []; 
  },
    // 遅刻数の計算
    lateCount: function () {
      let count = 0;
      this.start.forEach((value, i) => {
        const sTime = moment.duration(value, "HH:mm");
        const sBase = moment.duration(this.startBasic[i], "HH:mm");
        if (sBase.hours() === 0 && sBase.minutes() === 0) {
          return count;
        }
        const diff = sTime.subtract(sBase);
        if (
          diff > 0 &&
          this.attendance1[i] !== ConstList.SHIFT &&
          this.attendance2[i] !== ConstList.SHIFT &&
          this.attendance1[i] !== ConstList.HOLIDAY &&
          this.attendance1[i] !== ConstList.MORNING_PAID &&
          this.attendance1[i] !== ConstList.MORNING_SUBSTITUTE
        ) {
          count++;
        }
      });
      // const list = this.late
      // list.splice(0, 1, count)
      return count;
    },
    // 早退数の計算
    earlyCount: function () {
      let count = 0;
      this.end.forEach((value, i) => {
        const eTime = moment.duration(value, "HH:mm");
        const eBase = moment.duration(this.endBasic[i], "HH:mm");
        if (eTime.hours() === 0 && eTime.minutes() === 0) {
          return count;
        }
        const diff = eBase.subtract(eTime);
        if (
          diff > 0 &&
          this.attendance1[i] !== ConstList.SHIFT &&
          this.attendance2[i] !== ConstList.SHIFT &&
          this.attendance1[i] !== ConstList.HOLIDAY &&
          this.attendance2[i] !== ConstList.AFTERNOON_PAID &&
          this.attendance2[i] !== ConstList.AFTERNOON_SUBSTITUTE
        ) {
          count++;
        }
      });
      // const list = this.early
      // list.splice(0, 1, count)
      return count;
    },
    // 有給消化の計算
    usePaid: function () {
      let count = 0;
      this.attendance1.forEach((value, i) => {
        if (count < 0) {
          return count;
        }
        if (value === ConstList.PAID) {
          count++;
        }
        if (
          value === ConstList.MORNING_PAID ||
          this.attendance2[i] === ConstList.AFTERNOON_PAID
        ) {
          count = count + 0.5;
        }
      });
      return count;
    },
    // 今月残有給の計算
    savePaidCalc: function () {
      const last = Number(this.paid ?? 0);
      const get = Number(this.get_paid ?? 0);
      const take = Number(this.usePaid ?? 0);
      const total = last + get - take;
      return total.toFixed(1); // 小数あり得るため
    },
    savePaidDisplay: function () {
      return (this.savePaid !== null && this.savePaid !== undefined && this.savePaid !== "")
        ? this.savePaid
        : this.savePaidCalc;
    },
    //代休発生の計算
    // 代休発生の計算（休日しきい値ルール：4h/8h）
    get_instead: function () {
      if (this.statusBtn) {
        return this.addInstead;
      }
      let count = 0;

      this.attendance1.forEach((att, i) => {
        if (att !== ConstList.HOLIDAY) return;

        // 実働（"HH:mm"）→ 分に変換。未入力/nullは除外
        const workStr = (this.total && this.total[i]) || (this.totalTime && this.totalTime[i]) || "";
        const workMin = this.hmToMinutes(workStr);
        if (!Number.isFinite(workMin)) return;

        // しきい値（分）
        const HALF_DAY_MIN = 240; // 4h
        const FULL_DAY_MIN = 480; // 8h

        if (workMin >= FULL_DAY_MIN) {
          // 8時間ちょうど／以上 → 1.0 日
          count += 1.0;
        } else if (workMin >= HALF_DAY_MIN) {
          // 4時間ちょうど／超〜8時間未満 → 0.5 日
          count += 0.5;
        }
        // 4時間未満 → 代休なし（0）
      });

      return count;
    },

    // 代休消化の計算
    useInstead: function () {
      let count = 0;
      this.attendance1.forEach((value, i) => {
        if (count < 0) {
          return count;
        }
        if (value === ConstList.SUBSTITUTE) {
          count++;
        }
        if (
          value === ConstList.MORNING_SUBSTITUTE ||
          this.attendance2[i] === ConstList.AFTERNOON_SUBSTITUTE
        ) {
          count = count + 0.5;
        }
      });
      // const list = this.take_instead
      // list.splice(0, 1, count)
      return count;
    },
    // 今月残代休の計算
    saveInsteadCalc: function () {
      const last = Number(this.instead ?? 0);
      const get = Number(this.get_instead ?? 0);
      const take = Number(this.useInstead ?? 0);
      const total = last + get - take;
      return total.toFixed(1);
    },
    saveInsteadDisplay: function () {
      return (this.saveInstead !== null && this.saveInstead !== undefined && this.saveInstead !== "")
        ? this.saveInstead
        : this.saveInsteadCalc;
    },
    // 規定勤務日数の計算
    duration: function () {
      let count = 0;
      this.attendance1.forEach((value) => {
        if (value !== "" && value !== ConstList.HOLIDAY) {
          count++;
        }
      });
      return count;
    },
    // 規定勤務時間の計算
    durationTime: function () {
      // どこか1日でも「不正 or 休憩00:00」があれば、元の挙動どおり全体を "00:00" にする
      for (let i = 0; i < this.attendance1.length; i++) {
        if (this.attendance1[i] === ConstList.HOLIDAY) continue;

        const s = moment.duration(this.startBasic[i], "HH:mm");
        const e = moment.duration(this.endBasic[i],   "HH:mm");
        const b = moment.duration(this.breakBasic[i], "HH:mm");

        const diffCheck = e.clone().subtract(s).subtract(b);

        if (
          diffCheck.asMinutes() <= 0 ||                 // 負/ゼロ（不正）
          (b.hours() === 0 && b.minutes() === 0)        // 休憩00:00 → 元コード条件
        ) {
          return "00:00";
        }
      }

      // 全日OKなら、各日の基準(終-始-休)を合算
      let totalMinutes = 0;
      for (let i = 0; i < this.attendance1.length; i++) {
        if (this.attendance1[i] === ConstList.HOLIDAY) continue;

        const s = moment.duration(this.startBasic[i], "HH:mm");
        const e = moment.duration(this.endBasic[i],   "HH:mm");
        const b = moment.duration(this.breakBasic[i], "HH:mm");
        const diff = e.clone().subtract(s).subtract(b); // ここは健全値のみ

        totalMinutes += diff.hours() * 60 + diff.minutes();
      }

      const hTotal = Math.floor(totalMinutes / 60);
      const mTotal = totalMinutes % 60;

      return (
        (hTotal < 10 ? "0" + hTotal : hTotal) +
        ":" +
        (mTotal < 10 ? "0" + mTotal : mTotal)
      );
    },
    // 実務日数の計算
    totalForCalc() {
    return this.totalTime || [];
    },
    actual() {
      return (this.totalTime || []).filter(val => !!val).length;
    },
    actualTime() {
      return this.calcTotal(this.totalTime || []);
    },
    // 時間外時間の計算
    overTotal: function () {
      return this.calcTotal(this.overTime || []);
    },
    // 欠勤時間の計算
    absentTime: function () {
      return this.calcTotal(this.deduct || []);
    },
    // 夜勤時間の計算
    nightTotal: function () {
      return this.calcTotal(this.nightWork || []);
    },
    // 休日時間の計算
    holidayTotal: function () {
      return this.calcTotal(this.holiday || []);
    },
    termPaidDaysUsedValue() {
      const base = Number(this.paidDaysUsed ?? 0);
      const add  = Number(this.usePaid ?? 0);     
      const v = base + add;
      return Number.isFinite(v) ? v : 0;
    },
    termPaidDaysUsedLabel() {
      const v = this.termPaidDaysUsedValue;
      return Number.isInteger(v) ? String(v) : v.toFixed(1);
    },
    // 有給消化不足警告色付け
    paidDaysUsedStyle() {
      const v = Number(this.termPaidDaysUsedValue);
      if (!Number.isFinite(v)) return { color: 'black' };
      if (v < 3) return { color: 'red' };
      if (v < 5) return { color: 'orange' };
      return { color: 'black' };
    },
    // 有給消化不足警告文
    shouldWarnPaidDaysUsed() {
      const v = Number(this.termPaidDaysUsedValue);
      if (!Number.isFinite(v)) return false;
      return v < 5;
    },
    workTimeStatus() {
      const totalMin = this.hmToMinutes(this.actualTime);
      const minMin   = this.hmToMinutes(this.baseTimeMin[0]);
      const maxMin   = this.hmToMinutes(this.baseTimeMax[0]);

      const hasTotal = Number.isFinite(totalMin);
      const hasMin   = Number.isFinite(minMin);
      const hasMax   = Number.isFinite(maxMin);
      const BAND5H   = 5 * 60;

      // total 未入力や不正な場合のみ「基準時間内」
      if (!hasTotal) return { text: '基準時間内', color: 'green' };

      if (!hasMin && !hasMax) return { text: '基準時間内', color: 'green' };

      if (hasMax && totalMin > maxMin) {
        return { text: `【超過】${this.formatDiff(totalMin - maxMin)}`, color: 'red' };
      }
      if (hasMin && totalMin < minMin) {
        return { text: `【控除】${this.formatDiff(minMin - totalMin)}`, color: 'blue' };
      }
      // 上限 - 5H 以内 → オレンジ
      if (hasMax && totalMin >= (maxMin - BAND5H) && totalMin <= maxMin) {
        return { text: '基準時間内', color: 'orange' };
      }
      // 下限 + 5H 以内 → 水色
      if (hasMin && totalMin >= minMin && totalMin <= (minMin + BAND5H)) {
        return { text: '基準時間内', color: '#00BFFF' }; // water-light（お好みで 'deepskyblue' でも可
      }
      return { text: '基準時間内', color: 'green' };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/* サマリテーブル共通スタイル */
table th {
  text-align: center;
  vertical-align: middle;
}

table td {
  text-align: center;     /* データは中央寄せ */
  vertical-align: middle; /* 上下中央 */
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

button:disabled {
  cursor: not-allowed;
}

.summary-leave-table th[scope="row"] {
  width: 40px;            /* 有休・代休列だけ狭める。40〜60pxで調整可 */
  white-space: nowrap;    /* 折り返し防止 */
  text-align: center;     /* 中央寄せ */
  padding-left: 2px;      /* 余白を最小限に */
  padding-right: 2px;
}
</style>
